<template>
  <li class="sidebar-item pointer" @click.stop="showBackstage">
    <a class="text-wrap sidebar-link-custom sidebar-link waves-effect waves-dark">
      <span class="horizontal layout center">
        <aha-icon
          name="backstage"
          class="sidebar-link-icon"
          viewBox="0 0 24 25"
          width="34"
        />
        <span class="hide-menu nav-left-text">{{ $t('Show backstage') }}</span>
      </span>
    </a>
  </li>
</template>

<script>
import EventBus from '@/eventBus'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  methods: {
    showBackstage() {
      EventBus.$emit('open-backstage-window', 'from-context-menu')
      utils.mixpanelTracking(
        eventCategories.PRESENTING_MODE,
        'Context menu > Show backstage',
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.sidebar-item {
  width: unset;
  .sidebar-link {
    &:hover {
      .fas, .far {
        color: $primary-color;
      }
    }
    .sidebar-link-icon {
      font-size: 20px;
      margin-right: 12px;
    }
  }
  .active {
    background-color: rgba(0, 0, 0, 0.07);
  }
  .nav-left-text {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    font-size: 16px;
  }
}
</style>
